import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc';
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds';
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector';
const responseLenses = getResponseLenses(GET_PROJECT);
const { viewStreams } = responseLenses;
export const streamsSelector = (state, props) => {
    return viewStreams(getRecordSelector(state, props));
};
